/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Image, Box } from '@mantine/core';

// UI local components
import { LanguageSelect } from '@components/atoms/LanguageSelect';
import { SignIn } from '@features/auth/components/SignIn';
import { ForgotPassword } from '@features/auth/components/ForgotPassword/ForgotPassword';

// Images
import Ecology1Logo from '@assets/images/ecology-1.svg';
import InukLogo from '@assets/images/inuk-logo.svg';

// Styles
import classes from './login.module.css';

// Localstorage
import { useLocalStorage } from '@hooks/useLocalStorage';

// Hooks
import useStore from '@store/index';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const Auth = () => {
	/* ********************************** HOOKS ********************************* */
	const { i18n } = useTranslation();
	const [lng, setLng] = useLocalStorage('lng', 'fr');
	const { authForm, setAuthForm } = useStore();

	/* ******************************** HELPERS ******************************* */

	const handlenavigate = (_target: string) => {
		setAuthForm(_target);
	};

	function NavigateComponents() {
		if (authForm === 'signin')
			return <SignIn handlenavigate={handlenavigate} />;
		if (authForm === 'reset')
			return (
				<ForgotPassword handlenavigate={handlenavigate} />
			);
	}

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.layout}>
			<Box className={classes.header}>
				<Box className={classes.containerLogo}>
					<Image
						className={classes.logo}
						src={InukLogo}
						fit="contain"
					/>
				</Box>
				<Box className={classes.containerLanguage}>
					<LanguageSelect
						defaultValue={lng}
						onChange={(data: string) => {
							i18n.changeLanguage(data);
							setLng(data);
						}}
					/>
				</Box>
			</Box>
			<Box className={classes.content}>
				<Box className={classes.wrapper}>
					<Box className={classes.containerLeft}>
						<NavigateComponents />
					</Box>
					<Box className={classes.containerRight}>
						<Image src={Ecology1Logo} />
					</Box>
				</Box>
			</Box>
			<Box className={classes.footer} />
		</Box>
	);
};

export default Auth;
